import {Grid} from "@material-ui/core";
import {useCallback} from "react";
import {Button, FormWithRedirect, ReferenceInput,} from "react-admin";
import {DialogSelectInput} from "../../components/DialogSelectInput";
import {useOptions} from "../../shared/hooks/useOptions";
import {initInput} from "../../shared/utils";
import {
    FormWithRedirectRenderProps,
    Record,
    useCreate,
    useDataProvider,
    useEditContext,
    useNotify,
    useRefresh,
} from "ra-core";
import Add from "@material-ui/icons/Add";
import {OnChange} from "react-final-form-listeners";
import {NumberInput} from "../../components/NumberInput";
import {TariffClientDatagrid} from "../../components/TariffClientDatagrid";

interface AddDeliveryItemFormProps {
  disabled?: boolean;
}
export const AddDeliveryItemForm = (props: AddDeliveryItemFormProps) => {
  const { disabled } = props;
  const { record } = useEditContext();
  const { data: optionsTariffs } = useOptions("tariffs", "GET");
  const { data: options } = useOptions("delivery-items", "GET");
  const [create] = useCreate();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const onSubmit = useCallback(
    (values: Partial<Record>) => {
      create("delivery-items", values, {
        onSuccess: () => {
          notify("ra.notification.created", "success");
          refresh();
        },
        onFailure: () => notify("ra.notification.bad_item", "error"),
      });
    },
    [create, notify, refresh]
  );

  const updateQuantity = (
    value: number,
    formProps: FormWithRedirectRenderProps
  ) => {
    dataProvider
      .getOne("sub-tariffs", {
        id: value,
      })
      .then(({ data }) => {
        if (record) {
          if (data.quantity_type === "CO" && record.packages_number) {
            formProps.form.change("quantity", record.packages_number);
          } else if (data.quantity_type === "PE" && record.weight) {
            formProps.form.change("quantity", record.weight);
          }
        }
      });
  };

  return options && optionsTariffs ? (
    <FormWithRedirect
      save={onSubmit}
      initialValues={{ delivery: record?.id }}
      render={(formProps) => (
        <>
          <OnChange name="tariff">
            {(value, previous) => {
              if (value) {
                updateQuantity(value, formProps);
              }
            }}
          </OnChange>

          <Grid spacing={2} container alignItems="center">
            <Grid item xs={5}>
              <ReferenceInput
                {...initInput("tariff", options, disabled)}
                reference="tariffs-client"
                filter={{ delivery: record?.id }}
                helperText={false}
              >
                <DialogSelectInput helperText={false} optionText="label">
                  <TariffClientDatagrid options={optionsTariffs} />
                </DialogSelectInput>
              </ReferenceInput>
            </Grid>
            <Grid item xs={5}>
              <NumberInput
                helperText={false}
                {...initInput("quantity", options, disabled)}
              />
            </Grid>
            <Grid item xs={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={formProps.handleSubmit}
                label="Aggiungi"
                title="Aggiungi servizio"
              >
                <Add />
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    />
  ) : null;
};
